export function stripTrailingSlashes(path: string): string {
  return path.replace(/\/+$/, "")
}
